<template>
  <div
    class="bg-surface-container-low hover:bg-surface-container-highest rounded-small text-on-surface-variant text-label-large flex max-w-52 cursor-pointer items-center gap-2 px-2 py-1 text-center"
  >
    <span class="hidden truncate lg:inline-block">{{
      organizationStore.currentOrganization.name
    }}</span>
    <BaseMemberAvatar size="40" :member="userStore.user" :omit-tooltip="true" />
  </div>
</template>

<script setup lang="ts">
  import BaseMemberAvatar from '../../../core/components/base/avatar/BaseMemberAvatar.vue'
  import { useOrganizationStore } from '../../../stores/organization.store'
  import { useUserStore } from '../../../stores/user.store'

  const organizationStore = useOrganizationStore()

  const userStore = useUserStore()
</script>
